<template>
  <div
    class="main-menu menu-fixed menu-accordion menu-shadow sidebar-theme2"
    :class="[
      { 'expanded': !isVerticalMenuCollapsed || (isVerticalMenuCollapsed && isMouseHovered) },
      skin === 'semi-dark' ? 'menu-light' : 'menu-light'
    ]"
    @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)"
  >
    <!-- main menu header-->
    <div class="navbar-header expanded">
      <slot
        name="header"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        :toggleCollapsed="toggleCollapsed"
        :collapseTogglerIcon="collapseTogglerIcon"
      >
        <ul class="nav navbar-nav flex-row">

          <!-- Logo & Text -->
          <li class="nav-item mr-auto">
            <b-link
              class="navbar-brand"
              to="/"
            >
              <span class="brand-logo">
                <img
                  src="@/assets/images/logo/logo.png"
                  alt="VEROlabs Logo"
                  style="max-width:9rem"
                >
              </span>
              <!-- <h2 class="brand-text">
                {{ appName }}
              </h2> -->
              <!-- <div>
                <user-dropdown title="Caitriona Balfe" subtitle="Admin" />
              </div> -->

            </b-link>
          </li>

          <!-- Toggler Button -->
          <!-- <li class="nav-item nav-toggle">
            <b-link class="nav-link modern-nav-toggle">
              <feather-icon
                icon="XIcon"
                size="20"
                class="d-block d-xl-none"
                @click="toggleVerticalMenuActive"
              />
              <feather-icon
                :icon="collapseTogglerIconFeather"
                size="20"
                class="d-none d-xl-block collapse-toggle-icon"
                @click="toggleCollapsed"
              />
            </b-link>
          </li> -->
        </ul>
      </slot>
    </div>
    <!-- / main menu header-->

    <!-- Shadow -->
    <div
      :class="{'d-block': shallShadowBottom}"
      class="shadow-bottom"
    />

    <!-- main menu content-->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      :collapse-toggler-prop="collapseTogglerIcon"
      class="main-menu-content scroll-area"
      tagname="ul"
      @ps-scroll-y="evt => { shallShadowBottom = evt.srcElement.scrollTop > 0 }"
    >
      <vertical-nav-menu-items
        :items="navMenuItems"
        :rerender="rerender"
        class="navigation navigation-main"
      />
    </vue-perfect-scrollbar>
    <!-- /main menu content-->
  </div>
</template>

<script>

import navMenuItems from '@/navigation/vertical/'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { BLink, BImg } from 'bootstrap-vue'
import { provide, computed, ref } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import { $themeConfig } from '@themeConfig'
import UserDropdown from '@/@core/layouts/components/app-navbar/components/UserDropdown.vue'
import { loadDynamicCategoryRoutes } from '@/router/index'
import { getUserData } from '@/auth/utils'
import useVerticalNavMenu from './useVerticalNavMenu'
import VerticalNavMenuItems from './components/vertical-nav-menu-items/VerticalNavMenuItems.vue'

export default {
  components: {
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    BLink,
    BImg,
    UserDropdown,
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      rerender: false,
    }
  },
  mounted() {
    // listen for category creation events
    this.$root.$on('categoryCreated', () => {
      this.refreshMenu()
    })
  },
  beforeDestroy() {
    this.$root.$off('categoryCreated')
  },
  methods: {
    refreshMenu() {
      loadDynamicCategoryRoutes(this.$router)
      this.rerender = !this.rerender
    },
  },
  setup(props) {
    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered,
    } = useVerticalNavMenu(props)

    const { skin } = useAppConfig()

    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false)

    provide('isMouseHovered', isMouseHovered)

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    const collapseTogglerIconFeather = computed(() => (collapseTogglerIcon.value === 'unpinned' ? 'CircleIcon' : 'DiscIcon'))

    // App Name
    const { appName, appLogoImage } = $themeConfig.app

    const resolveNavMenuItems = computed(() => {
      const userData = getUserData()
      return navMenuItems.map(item => {
        if (item.route && item.route.name === 'institution_profile') {
          // Clone the item to avoid mutating the original static array directly if needed,
          // though map returns a new array, the objects inside are references.
          // Ideally we should deep clone or just create a new object for the modified item.
          return {
            ...item,
            route: {
              ...item.route,
              params: {
                ...item.route.params,
                id: (userData && userData.institution) ? userData.institution.id : null,
              },
            },
          }
        }
        return item
      })
    })

    return {
      navMenuItems: resolveNavMenuItems,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Name
      appName,
      appLogoImage,
    }
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";
</style>
